import { connect } from 'react-redux';
import { CANCEL_FOR_ANY_REASON } from '../../products';
import { useProductData } from '../../common/hook/useProductData';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { getSelected } from '../../single-choice/utils/selection';
import { ProductCardLayoutType } from '../../common/models/product';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  Main: MAIN_CARD_LAYOUT
} = ProductCardLayoutType;
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CANCEL_FOR_ANY_REASON;
const mainCardTranslations = {
  additionalInformation: 'cancelForAnyReasonAdditionalSalesText',
  persuasionContent: 'cancelForAnyReasonPersuasionContent',
  readMoreContent: 'cancelForAnyReasonReadMoreModalContent',
  abstractContent: 'cancelForAnyReasonAbstract',
  title: 'cancelForAnyReasonTitle',
  upSell: 'cancelForAnyReasonUpSell'
};
const CancelForAnyReason = ({
  className,
  form,
  isSelected,
  order,
  productCode,
  productPosition,
  sellSpecification
}) => {
  const {
    productData,
    rootElement
  } = useProductData({
    className,
    form,
    isSelected,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productCode,
    productPosition,
    sellSpecification,
    texts: mainCardTranslations,
    layoutType: MAIN_CARD_LAYOUT
  });
  if (!productData) {
    return null;
  }
  return /*#__PURE__*/_jsx(ProductLayout, {
    productData: productData,
    ref: rootElement
  });
};
const mapStateToProps = (state, {
  form
}) => {
  return {
    isSelected: getSelected(PRODUCT_NAME, form)(state)
  };
};
export default connect(mapStateToProps)(CancelForAnyReason);
//# sourceMappingURL=CancelForAnyReason.js.map